export enum CommunicationPermissions {
  RequestClaimsCustomSMS = 'COMMS.CLAIMS.CUSTOM_SMS.REQUEST',
  GetClaimsCustomSMSRequests = 'COMMS.CLAIMS.CUSTOM_SMS.GET',
  ActionClaimsCustomSMSRequests = 'COMMS.CLAIMS.CUSTOM_SMS.ACTION',
}
